




























import { onBeforeUnmount, onMounted, Ref, ref } from "@vue/composition-api";
import { UseMediaHero } from "./media-hero.state";
import { MediaHeroItem } from "./model";
import Vue from "vue";
import { clone, delayBy, emptyFn } from "@/fp";
import anim from "animejs";
import { onKey } from "@/common/dom.functions";
export default Vue.extend({
  setup() {
    const is_show = ref(false);
    const media_item: Ref<MediaHeroItem | null> = ref(null);
    const initial_el_position: Ref<DOMRect | null> = ref(null);
    let pending_promise: Function;
    const is_anim_finished = ref(false);
    const get_anim_end_values = () => {
      const width = innerWidth / 1.5;
      const height = width / 1.7;
      return {
        top: (innerHeight - height) / 2 + "px",
        left: (innerWidth - width) / 2 + "px",
        width: width + "px",
        height: height + "px",
      };
    };

    const img_el = () => document.getElementById("hero-img") as HTMLElement;

    const set_el_position = (el: HTMLElement, rect: DOMRect) => {
      el.style.position = "absolute";
      el.style.width = rect.width + "px";
      el.style.top = rect.top + "px";
      el.style.left = rect.left + "px";
      el.style.opacity = "1";
    };

    const animate_el_in = (el: HTMLElement) => {
      const { top, left, width, height } = get_anim_end_values();
      anim({
        targets: el,
        duration: 300,
        easing: "linear",
        top,
        left,
        width,
        height,
      });
    };

    const animate_el_out = (el: HTMLElement) => {
      const { top, left, width, height } = initial_el_position.value!;
      el.animate(
        [
          {
            top: top + "px",
            left: left + "px",
            width: width + "px",
            height: height + "px",
          },
        ],
        {
          duration: 300,
          fill: "forwards",
          easing: "ease-out",
        }
      );
    };

    UseMediaHero.set_root_listener({
      on_show: async (item) => {
        return new Promise((resolve) => {
          pending_promise = resolve;
          is_show.value = true;
          media_item.value = item;
          initial_el_position.value = clone(
            media_item.value!.element.getBoundingClientRect()
          );
          const { width, height } = getComputedStyle(media_item.value!.element);
          initial_el_position.value.width = Number.parseFloat(width);
          initial_el_position.value.height = Number.parseFloat(height);

          delayBy(100).then(() => {
            const el = img_el();
            set_el_position(el, initial_el_position.value!);
            media_item.value!.element.style.opacity = "0";
            animate_el_in(el);
            delayBy(300).then(() => {
              is_anim_finished.value = true;
            });
          });
        });
      },
      on_hide: async () => {
        await delayBy(300);
        media_item.value!.element.style.opacity = "1";
        media_item.value = null;
      },
    });

    const reset_values = () => {
      if (!media_item.value) {
        return;
      }
      media_item.value!.element.style.opacity = "1";
      initial_el_position.value = null;
      img_el().style.opacity = "0";
      is_show.value = false;
      is_anim_finished.value = false;
      media_item.value = null;
      pending_promise();
    };

    const close_media_hero = async () => {
      animate_el_out(img_el());
      await delayBy(300);
      reset_values();
    };

    const subs = {
      esc: emptyFn(),
    };

    onMounted(() => {
      subs.esc = onKey("Escape")(reset_values);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return { media_item, close_media_hero, is_show, is_anim_finished };
  },
});
